module.exports = __webpack_public_path__ + "img/NoGrade.922d4f52.png";